<form (ngSubmit)="onSubmit()">
	<div>
		<div class="flex justify-between mb-4">
			<span class="text-xl">Export to LEAP</span>
		</div>
	</div>

	<mat-dialog-content class="border-t-2 border-b-2">
		<div class="w-full">
			<img
				class="w-[202px] h-[200px] mr-auto ml-auto mt-0 mb-0"
				src="assets/images/leap/woman-holding-doc.png"
			/>
		</div>
		<div class="w-full">
			<p>
				Your accounting data will be exported to LEAP and this will <br />
				replace any past exports. Are you sure?
			</p>
			<br />
			<p>
				Last export: <b>{{ lastExportedAt }}</b>
			</p>
		</div>
	</mat-dialog-content>

	<mat-dialog-actions>
		<div class="w-full">
			<div class="flex justify-end gap-x-4 mt-4">
				<ui-button
					label="Cancel"
					color="gray"
					[style]="'outline'"
					mat-dialog-close
				></ui-button>
				<ui-button
					[loading]="exporting"
					[disabled]="exporting"
					label="Confirm"
					type="submit"
				></ui-button>
			</div>
		</div>
	</mat-dialog-actions>
</form>
